export class UserProxy{
    constructor (id, fullname, phone, note, authorities ){
    this.id=id
    this.fullname=fullname
    this.phone=phone
    this.note=note
    this.authorities=authorities
    }
}